<div class="pdf-form-filler-container">
  @if (loading()) {
  <div class="loader-container">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  }

  @if (error()) {
  <div class="alert alert-danger" role="alert">
    {{ error() }}
  </div>
  }

  @if (!showResult()) {
  <form [formGroup]="form" (ngSubmit)="submit()" class="pdf-form">
    <div class="pdf-pages-container">
      @for (page of pages(); track page.index) {
      <div class="pdf-page-wrapper"
           [style.width.px]="page.width > 0 ? page.width : 'auto'"
           [style.height.px]="page.height > 0 ? page.height : 'auto'">
        
        <canvas #pdfCanvas class="pdf-canvas"></canvas>

        <div class="pdf-fields-overlay">
          @for (field of fieldsForPage()(page.index); track field.name) {
            @if (field.cssRect) {
              <input
                [type]="field.type"
                [formControlName]="field.name"
                [attr.aria-label]="field.name"
                [title]="field.name"
                class="pdf-overlay-input"
                [class.is-checkbox]="field.type === 'checkbox'"
                [style.left.px]="field.cssRect.left"
                [style.top.px]="field.cssRect.top"
                [style.width.px]="field.cssRect.width"
                [style.height.px]="field.cssRect.height"
              />
            }
          }
        </div>
      </div>
      }
    </div>

    @if (pages().length > 0 && !loading()) {
    <div class="form-actions mt-3 mb-3 text-center d-flex justify-content-center gap-2">
      <button type="submit" class="btn btn-primary btn-lg" [disabled]="form.invalid || loading()">
        Save Form
      </button>
      <button type="button" class="btn btn-warning btn-lg" (click)="openFedexModal()" [disabled]="loading()">
        Buy FedEx
      </button>
    </div>
    }
  </form>
  } @else {
  <div class="pdf-result-container">
    <iframe [src]="resultUrl()" class="pdf-result-iframe" title="Filled PDF Document"></iframe>
  </div>
  }

  <app-fedex-shipping-modal
    [visible]="showFedexModal()"
    [prefillData]="fedexPrefillData()"
    [loading]="fedexLoading()"
    [error]="fedexError()"
    (close)="onFedexClose()"
    (shippingChoice)="onShippingChoice($event)"
  />
</div>
